import { makeAutoObservable } from 'mobx';

const initialState = {
  loading: true,
  searching: false,
  admindata: [],
  alladmins: [],
  totalAdmins: 0,
  selectedStaff: {},
  showAllRecords: false,
  showAllStaff: false,
  page: 0,
  perPage: 15,
};

class AdminStore {
  constructor() {
    Object.assign(this, initialState);
    makeAutoObservable(this, {}, { autoBind: true });
    this.loadState();
  }

  get adminPages() {
    return this.totalAdmins || 0;
  }

  removeFromSession() {
    this.resetState();
    sessionStorage.removeItem('AdminStore');
  }

  setLoading = (val) => {
    this.loading = val;
    this.saveState();
  };

  setSearching = (val) => {
    this.searching = val;
    this.saveState();
  };

  setShowAllRecords = (checked) => {
    this.showAllRecords = checked;
    this.showNeedEmail = false;
    this.saveState();
  };

  setShowAllStaff = (checked) => {
    this.showAllStaff = checked;
    this.saveState();
  };

  setSelectedStaff = (obj) => {
    this.selectedStaff = obj;
    this.saveState();
  };

  setAllAdmins = (data) => {
    this.alladmins = data;
    this.saveState();
  };

  setAdminData = (data) => {
    if (data) {
      this.admindata = data;
      this.totalAdmins = data.length;
      this.saveState();
    }
  };

  setTotalAdmins = (val) => {
    this.totalAdmins = val;
    this.saveState();
  };

  setPage = (page) => {
    this.page = page;
    this.saveState();
  };

  async handlePageChange(ev, val) {
    this.searching = true;
    this.page = val;
    this.searching = false;
    this.saveState();
  }

  handleChangeRowsPerPage = (event) => {
    this.perPage = parseInt(event.target.value, 10);
    this.page = 0;
    this.saveState();
  };

  saveState() {
    const state = {
      admin: this.admin,
    };
    sessionStorage.setItem('AdminStore', JSON.stringify(state));
  }

  loadState() {
    const state = JSON.parse(sessionStorage.getItem('AdminStore'));
    if (state) {
      Object.assign(this, state);
    }
  }
}

export default AdminStore;
